import { Divider, Empty, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { PermissionRow } from './PermissionRow'
import { useStyles } from './styles'
import { PermissionSectionView } from './types'

type Props = {
  sections: PermissionSectionView[]
  selected: Set<string>
  showGroups: boolean
  setContainer: (node: HTMLDivElement | null) => void
  onToggle: (key: string, checked: boolean) => void
}

export const PermissionsList = ({
  sections,
  selected,
  showGroups,
  setContainer,
  onToggle
}: Props) => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  return (
    <div ref={setContainer} className={styles.list}>
      {!sections.length && (
        <Empty
          className={styles.empty}
          description={t('permissions.empty_state')}
        />
      )}

      {sections.map((section, index) => (
        <div key={section.key} data-section={section.key}>
          <Flex vertical gap={4} className={styles.sectionHeader}>
            <Flex gap={8} align="baseline" justify="space-between">
              <Flex gap={8} align="baseline">
                <Typography.Text
                  type="secondary"
                  className={styles.sectionIndex}
                >
                  {String(index + 1).padStart(2, '0')}
                </Typography.Text>

                <Typography.Text strong>{section.title}</Typography.Text>
              </Flex>

              <Typography.Text type="secondary">
                {t('permissions.active_of_total', {
                  active: section.activeCount,
                  total: section.totalCount
                })}
              </Typography.Text>
            </Flex>

            {showGroups && section.groupTitle && (
              <Typography.Text type="secondary">
                {section.groupTitle}
              </Typography.Text>
            )}
          </Flex>

          {section.options.map((option) => (
            <Flex vertical key={option.key}>
              <PermissionRow
                option={option}
                checked={selected.has(option.key)}
                onToggle={onToggle}
              />

              <Divider className={styles.divider} />
            </Flex>
          ))}
        </div>
      ))}
    </div>
  )
}
